module.exports = __webpack_public_path__ + "fonts/Heroicons.7dc977b0.woff2";